import { jsx as n } from "react/jsx-runtime";
import { Knob as u } from "primereact/knob";
import { useStateTogether as m } from "react-together";
function i({ rtKey: e, ...o }) {
  const [t, r] = m(e, 0);
  return /* @__PURE__ */ n(u, { ...o, value: t || 0, onChange: (a) => r(a.value) });
}
export {
  i as default
};
